//------------------------------------------------------------------------
// Applies current <picture> image source as “background-image” on the target wrapper
//
// Example:
//
// <div class="js-background-image">
//   <picture>
//     <!--[if IE 9]><video style="display: none;"><![endif]-->
//     <source srcset="<%= asset_path("dev/800x450.png") %>" media="(min-width: 400px)">
//     <!--[if IE 9]></video><![endif]-->
//     <img src="<%= asset_path("dev/400x225.png") %>">
//   </picture>
// </div>
//------------------------------------------------------------------------
'use strict';
import Backbone from 'backbone';

var documentClasses = document.documentElement.className;

// Detect “object-fit” support
// Note: Edge 16+ only supports “object-fit” on img tags, but that’s all we’re using it for.
// https://caniuse.com/#feat=object-fit
var supportsObjectFit = "objectFit" in document.documentElement.style;

var bgPicture = Backbone.View.extend({
  initialize: function() {
    // Do nothing if `object-fit` is supported
    if (supportsObjectFit) {
      return false;
    }

    var self = this;

    // Save reference to <img> tag
    this.img = [].slice.call(self.el.getElementsByTagName('img'))[0];

    if (!this.img) {
      console.warn('BACKGROUND PICTURE: element does not have child img elements')
      return false;
    }

    // Check if “currentSrc” is supported

    this.isModern = (this.img && typeof this.img.currentSrc !== 'undefined') ? true : false;

    // Bind to onload event, which will fire whenever the source changes
    this.img.onload = function() {
      self.update('onload');
    }

    // Update if “onload” event fired before this script was parsed
    // (we know this happened if “currentSrc” has already been set)
    if ( this.isModern && this.img.currentSrc.length ) {
      this.update('init');
    }
    else if ( this.img.src.length ) {
      this.update('old init');
    }
  },

  // Update parent wrapper
  update: function(msg) {
    // console.log(msg, 'currentSrc: ' + this.img.currentSrc, 'src: ' + this.img.src);
    var source = this.isModern ? this.img.currentSrc : this.img.src;

    if ( !source.length ) {
      this.el.style.backgroundImage = '';
    }
    else {
      this.el.style.backgroundImage = "url('" + source + "')";
    }
  }
});

// Only run if CSS “object-fit” isn’t supported
if (!supportsObjectFit) {
  var els = document.querySelectorAll('.js-background-image');

  for ( var i=0, len=els.length; i<len; i++ ) {
    new bgPicture({ el: els[i] });
  }
}

export default bgPicture;